import React from 'react';
import { Clock, ShieldCheck, ThumbsUp } from 'lucide-react';

export function TrustIndicators() {
  const indicators = [
    {
      icon: Clock,
      title: "24/7 Notdienst",
      description: "Rund um die Uhr, 365 Tage im Jahr für Sie da"
    },
    {
      icon: ShieldCheck,
      title: "Zertifizierte Fachkräfte",
      description: "Geprüfte Qualität und fachgerechte Ausführung"
    },
    {
      icon: ThumbsUp,
      title: "Zufriedenheitsgarantie",
      description: "Transparente Preise und höchste Kundenzufriedenheit"
    }
  ];

  return (
    <section className="py-12 bg-brand-black border-y border-white/10 relative z-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
          {indicators.map((item, index) => (
            <div 
              key={index}
              className="flex flex-col items-center p-6 bg-white/5 rounded-2xl border border-white/5 hover:bg-white/10 transition-colors animate-[fadeInUp_0.6s_ease-out_both]"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-16 h-16 rounded-full bg-brand-gold/20 flex items-center justify-center mb-6 text-brand-gold shadow-[0_0_20px_rgba(197,160,89,0.2)]">
                <item.icon className="w-8 h-8" />
              </div>
              <h2 className="text-xl text-white font-bold mb-3">{item.title}</h2>
              <p className="text-gray-400 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
